import { render, staticRenderFns } from "./CoozzyContactPersonIcon.vue?vue&type=template&id=2132c90e&scoped=true"
import script from "./CoozzyContactPersonIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyContactPersonIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyContactPersonIcon.vue?vue&type=style&index=0&id=2132c90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2132c90e",
  null
  
)

export default component.exports